import React from "react";
import { ScreenHeading } from "../../componets/ScreenHeading/ScreenHeading";
import { ScrollService } from "../../componets/ScrollService";
import { Animations } from "../../componets/Animations";
import "./AboutMe.css";

export function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTANTS = {
    description:
      "My name is Andreas studied IT with a specialization in Frontend and Mobile Dev. " +
      "Have always been interested in technology but wasn't until the summer 2019 that I began coding." +
      "After some youtube videos and simple JS and Python projectImages I found, after sometime, something I could see myself doing professionally. " +
      "I have a multicultural background due to my upbringing, in Saudi Arabia, Singapore and Dubai, fluent in both English and Norwegian " +
      "I have an agreeable personality, find it easy to work with others but am not afraid to take charge and initiative when needed",
    highlights: {
      header: "Interests",
      bullets: ["Programming", "Board Games", "Cooking", "Gaming"],
    },
  };

  const renderHighlight = () => {
    return SCREEN_CONSTANTS.highlights.bullets.map((value, i) => (
      <div className={"highlight"} key={i}>
        <div className={"highlight-blob"} />
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div
      className={"about-me-container screen-container fade-in"}
      id={props.id || ""}
    >
      <div className={"about-me-parent"}>
        <ScreenHeading title={"About Me"} subHeading={"Who am I?"} />
        <div className={"about-me-card"}>
          <div className={"about-me-details"}>
            <span className={"about-me-description"}>
              {SCREEN_CONSTANTS.description}
            </span>
            <div className={"about-me-highlights"}>
              <div className={"highlight-heading"}>
                <span>{SCREEN_CONSTANTS.highlights.header}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className={"about-me-options"}>
              <button
                className={"btn primary-btn"}
                onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              >
                {""}
                Contact me{""}
              </button>
              <a href="myCV.pdf" download="My CV.pdf">
                <button className={"btn highlighted-btn"}>
                  Download My CV
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
